import { Location, NgIf, NgTemplateOutlet, NgFor, CurrencyPipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { faAngleLeft, faAngleRight, faCalendar, faFileDownload, faSortUp, faSortDown, faRotateLeft, faSortAmountDownAlt } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from '../report.service';
import { TableControlService } from '../table-control.service';
import { Subject, debounceTime } from 'rxjs';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbPagination } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-reports-project-balances',
    templateUrl: './reports-project-balances.component.html',
    styleUrls: ['./reports-project-balances.component.css'],
    imports: [NgbTooltip, FaIconComponent, NgIf, NgTemplateOutlet, NgFor, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbPagination, CurrencyPipe]
})
export class ReportsProjectBalancesComponent implements OnInit {
  //Screensize event Listener
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resizeSubject.next((event.target as Window).innerWidth);
  }

  // Variable Subject
  private resizeSubject: Subject<number> = new Subject<number>();

  // Properties
  entries: any[] = [];
  entryCount: number = 0;
  isMobileView: boolean = false;

  sortOptions = [
    { label: 'Client', value: 'c.client_name' },
    { label: 'Project', value: 'proj.project_name' }
  ];
  sortBy: string = 'c.client_name';
  sortDirection: string = 'ASC';

  // Table Controls
  tableControls: TableControlService;

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faCalendar = faCalendar;
  faFileDownload = faFileDownload;
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  faRotateLeft = faRotateLeft;
  faSortAmountDownAlt = faSortAmountDownAlt;

  // Get isMobile value in reactive way
  public get isMobile(): boolean {
    return this.isMobileView;
  }

  constructor(private reportService: ReportService,
    public location: Location) {
      this.resizeSubject.pipe(
        debounceTime(100)
      ).subscribe(width => {
        if (width <= 768) {
          this.checkScreenSize(width);
        } else {
          this.isMobileView = false;
          this.tableControls.setLimit(20);
        }
      });
    }

  ngOnInit(): void {
    this.tableControls = new TableControlService('Reports.PartiallyInvoicedProjects', true, 'c.client_name', 'ASC');
    this.tableControls.refresh.subscribe(() => {
      this.getPartiallyInvoicedProjectsReport();
    });
    this.getPartiallyInvoicedProjectsReport();
    this.checkScreenSize();
  }

  // Get Partially Invoiced Projects Report
  private getPartiallyInvoicedProjectsReport(): void {
    let params = this.tableControls.getParams();
    if(this.isMobile) {
      params.sortBy = this.sortBy;
      params.sortDirection = this.sortDirection;
    };
    this.reportService.getPartiallyInvoicedProjectsReport(params).subscribe((reportData) => {
      this.entries = reportData.entries;
      this.entryCount = reportData.count;
    });
  }

  //Set isMobile value and set table limit base on screen size
  checkScreenSize(width?: number) {
    let screenWidth = width || window.innerWidth;
    this.isMobileView =  screenWidth <= 768;
    this.isMobileView ? this.tableControls.setLimit(5): this.tableControls.setLimit(20);
  }

  // Sorting
  sorting(column: string): void {
    if (column != this.sortBy) this.sortDirection = 'ASC';
    if (column == this.sortBy) this.sortDirection = (this.sortDirection == 'ASC') ? 'DESC' : 'ASC';
    this.sortBy = column;
    this.getPartiallyInvoicedProjectsReport();
  }
}
